import {Injectable} from '@angular/core';
import {BaseDao} from '../../base-dao';
import {Guac, RemoteAppHtml5} from '../../models';
import {R2CloudHttpApiService} from '../../r2-cloud-http-api.service';
import {KluhManagerValidator} from '../../validators/kluh-manager-validator';
import {Observable} from 'rxjs/internal/Observable';

@Injectable()
export class GuacDaoService extends BaseDao<Guac> {

    constructor(http: R2CloudHttpApiService, validatorDAO: KluhManagerValidator) {
        super(http, validatorDAO, 'guac');
    }

    getToken(remoteAppHtml5: RemoteAppHtml5): Observable<Guac> {
        return this.http.post<Guac>(this.url + '/token/', remoteAppHtml5);
    }
}
